import { mercuryApi } from '$api'
import { PayrollSystem } from '$constants'
import { PayRun, transformPayRunOnGet } from '$models'

/**
 * Get PayRun by id
 * @param id PayRun id
 * @param payrollSystem Payroll System that the PayRun belongs to
 * @param signal AbortSignal to cancel the request
 * @returns Promise<PayRun>
 */
export const getPayRunById = async (
  id: string,
  payrollSystem: PayrollSystem,
  signal?: AbortSignal
): Promise<PayRun> => {
  const result = await mercuryApi.get<PayRun>(
    `/payroll/pay-runs/${id}?system=${payrollSystem}`,
    undefined,
    signal
  )

  return transformPayRunOnGet(result)
}

/**
 * Update PayRun
 * @param payRun PayRun to update
 * @param payrollSystem Payroll System that the PayRun belongs to
 * @param signal AbortSignal to cancel the request
 * @returns Promise<PayRun>
 */
export const updatePayRun = async (
  payRun: PayRun,
  payrollSystem: PayrollSystem,
  signal?: AbortSignal
): Promise<PayRun> => {
  const result = await mercuryApi.update(
    `/payroll/pay-runs/${payRun.id}?system=${payrollSystem}`,
    payRun,
    signal
  )

  return transformPayRunOnGet(result)
}

/**
 * Sync employee wages
 * @param payRunId PayRun id
 * @param employeeIds Array of employee ids to sync
 * @param payrollSystem Payroll System that the PayRun belongs to
 * @param signal AbortSignal to cancel the request
 * @returns Promise<PayRun>
 */
export const syncWages = async (
  payRunId: string,
  employeeIds: string[],
  payrollSystem: PayrollSystem,
  signal?: AbortSignal
): Promise<PayRun> => {
  const result = await mercuryApi.add(
    `/payroll/pay-runs/sync?system=${payrollSystem}`,
    {
      payRunId,
      employeeIds,
    },
    signal
  )

  return transformPayRunOnGet(result)
}
